import { render, staticRenderFns } from "./delete-order.vue?vue&type=template&id=7541f928"
import script from "./delete-order.vue?vue&type=script&lang=js"
export * from "./delete-order.vue?vue&type=script&lang=js"
import style0 from "./delete-order.vue?vue&type=style&index=0&id=7541f928&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports